import script from "./TarjaDeAcessoComoOutro.vue?vue&type=script&lang=ts&setup=true"
export * from "./TarjaDeAcessoComoOutro.vue?vue&type=script&lang=ts&setup=true"

import "./TarjaDeAcessoComoOutro.vue?vue&type=style&index=0&id=64c84e30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64c84e30"]])

export default __exports__